import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BuildHeader } from 'src/Utils/headerBuilder'
import { RequestMethods } from '../Helper/FetchHelpers'

export const fetchContractFiles = createAsyncThunk(
  'contractFiles/fetchFiles',
  async (contractId, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: RequestMethods.GET,
        headers: BuildHeader(),
      }

      const response = await fetch(
        `${window.extended.MYAPP_API_ENDPOINT}/contract/files/${contractId}`,
        requestOptions,
      )

      if (!response.ok) {
        throw new Error('Failed to fetch contract files')
      }

      return await response.json()
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const initialState = {
  files: [],
  loading: false,
  error: null,
  currentContractId: null,
}

const contractFilesSlice = createSlice({
  name: 'contractFiles',
  initialState,
  reducers: {
    clearContractFiles: (state) => {
      state.files = []
      state.currentContractId = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractFiles.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchContractFiles.fulfilled, (state, action) => {
        state.loading = false
        state.files = action.payload || []
        state.currentContractId = action.meta.arg
      })
      .addCase(fetchContractFiles.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.files = []
      })
  },
})

export const { clearContractFiles } = contractFilesSlice.actions
export default contractFilesSlice.reducer
